import { render, staticRenderFns } from "./ModalConfirmPaymentFail.vue?vue&type=template&id=225779df&scoped=true&"
import script from "./ModalConfirmPaymentFail.vue?vue&type=script&lang=ts&"
export * from "./ModalConfirmPaymentFail.vue?vue&type=script&lang=ts&"
import style0 from "./ModalConfirmPaymentFail.vue?vue&type=style&index=0&id=225779df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225779df",
  null
  
)

export default component.exports